import { useFetchItem, useFetchItems } from "./base-hooks";
import { CacheKey } from "../types/cache-keys";

const useFetchAllServiceCreation = (options?) => useFetchItems(`db/service-creation`, CacheKey.AllServiceCreation, {}, options);
const useFetchAllServiceCreationActivity = (options?) => useFetchItems(`db/service-creation-activity`, CacheKey.AllServiceCreationActivity, {}, options);
const useFetchAllStage = (options?) => useFetchItems(`db/stage`, CacheKey.AllStage, {}, options);
const useFetchAllPartner = (options?) => useFetchItems(`db/partner`, CacheKey.AllPartner, {}, options);
const useFetchAllPhase = (options?) => useFetchItems(`db/phase`, CacheKey.AllPhase, {}, options);
const useFetchAllGeo = (options?) => useFetchItems(`db/geo`, CacheKey.AllGeo, {}, options);
const useFetchAllMarketSegment = (options?) => useFetchItems(`db/market-segment`, CacheKey.AllMarketSegment, {}, options);
const useFetchAllAccountSegment = (options?) => useFetchItems(`db/account-segment`, CacheKey.AllAccountSegment, {}, options);
const useFetchAllAccountType = (options?) => useFetchItems(`db/account-type`, CacheKey.AllAccountType, {}, options);

const useFetchPartnerServiceCreation = (id, options?) => useFetchItems(`db/service-creation`, CacheKey.ServiceCreation, {partner: id, detailed: true}, options);
const useFetchServiceCreationActivity = (id, options?) => useFetchItems(`db/service-creation-activity`, CacheKey.ServiceCreationActivity, {service_creation: id}, options);
const useFetchPartner = (id, options?) => useFetchItem(`db/partner`, id, CacheKey.Partner, {}, options);
const useFetchPartners = (params?, options?) => useFetchItems('db/partner', CacheKey.Partner, params, options);


export {
  useFetchAllServiceCreation,
  useFetchAllServiceCreationActivity,
  useFetchAllMarketSegment,
  useFetchAllGeo,
  useFetchAllPhase,
  useFetchAllAccountType,
  useFetchAllAccountSegment,
  useFetchAllStage,
  useFetchAllPartner,
  useFetchPartnerServiceCreation,
  useFetchServiceCreationActivity,
  useFetchPartner,
  useFetchPartners,
}